module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAc0lEQVQoU3XPMQrCUBRE0RMSEBJTqGgVUtlmFdmCW3UP2rgAQTALsEhhYSPyIR/ih7xyuNx5k/m/Aiu8Y5wlQIMDbinQosMT9WT54DI37HBCiTPuwRKBLXqMWCOfah4RCOEXFY64YoNX+mTQ7zEsrUhG8QNDPQ4Jq5d45AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/x-icon.png
// module id = p+72
// module chunks = 12 16 18 20 21 33 44 45 46